function handleRequiredFields() {
  document.querySelectorAll('.bss-b2b-rf-field').forEach(field => {
    const required = field.querySelector('.required');
    const label = field.querySelector('label');

    if (required && label) {
      required.style.display = 'none';

      if (!label.querySelector('.required-label')) {
        const badge = document.createElement('span');
        badge.className = 'required-label';
        badge.textContent = ' 必須'; 

        label.appendChild(badge);
      }
    }
  });
}

handleRequiredFields();

const observer = new MutationObserver(handleRequiredFields);

observer.observe(document.body, {
  childList: true,
  subtree: true
});